var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdyen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2888,
    height: 932,
    viewBox: "0 0 2888 932",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M406.081 213.11H8.51917V340.976H269.774C286.812 340.976 298.171 355.183 298.171 369.39V593.866H241.377C224.338 593.866 212.979 579.659 212.979 565.451V403.488H102.23C45.4356 403.488 0 448.951 0 505.78V619.439C0 676.268 45.4356 721.732 102.23 721.732H508.311V315.402C508.311 258.573 462.875 213.11 406.081 213.11Z",
    fill: "#5C5C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M891.674 593.866H834.879C817.841 593.866 806.482 579.659 806.482 565.451V213.11H695.733C638.938 213.11 593.502 258.573 593.502 315.402V619.439C593.502 676.268 638.938 721.732 695.733 721.732H1101.81V0H888.834L891.674 593.866Z",
    fill: "#5C5C5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1485.18 593.866H1428.38C1411.34 593.866 1399.98 579.659 1399.98 565.451V213.11H1187V619.439C1187 676.268 1232.44 721.732 1289.24 721.732H1485.18V784.244H1195.52V932H1595.93C1652.72 932 1698.16 886.537 1698.16 829.707V213.11H1485.18V593.866Z",
    fill: "#5C5C5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2189.43 213.11H1780.51V619.439C1780.51 676.268 1825.94 721.732 1882.74 721.732H2283.14V593.866H2021.88C2004.85 593.866 1993.49 579.659 1993.49 565.451V340.976H2050.28C2067.32 340.976 2078.68 355.183 2078.68 369.39V531.354H2189.43C2246.22 531.354 2291.66 485.89 2291.66 429.061V315.402C2291.66 258.573 2246.22 213.11 2189.43 213.11Z",
    fill: "#5C5C5C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2782.93 213.11H2376.85V721.732H2589.83V340.976H2646.62C2663.66 340.976 2675.02 355.183 2675.02 369.39V721.732H2888V315.402C2885.16 258.573 2839.72 213.11 2782.93 213.11Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdyen);
export default __webpack_public_path__ + "static/media/adyen.c24daddb1bb3c12fa8f5df93480780b7.svg";
export { ForwardRef as ReactComponent };